import { render, staticRenderFns } from "./FourView.vue?vue&type=template&id=bbdb3778"
import script from "./FourView.vue?vue&type=script&lang=js"
export * from "./FourView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports